/* content.js: ported from zum-impulse, Alpine components registered on alpine:init */
(function () {
  'use strict';

  function reducedMotion() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  /* Embla is only loaded on product pages by theme.liquid. A carousel elsewhere injects it
     itself (url from data-embla-src) and waits for it. */
  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var found = document.querySelector('script[src="' + src + '"]');
      if (found && found.__loaded) { resolve(); return; }
      var s = found || document.createElement('script');
      s.addEventListener('load', function () { s.__loaded = true; resolve(); });
      s.addEventListener('error', reject);
      if (!found) { s.src = src; s.async = true; document.head.appendChild(s); }
    });
  }
  var corePromise = null;
  function ensureEmbla(root) {
    if (window.EmblaCarousel) return Promise.resolve();
    if (!corePromise) corePromise = loadScript(root.getAttribute('data-embla-src'));
    return corePromise;
  }

  document.addEventListener('alpine:init', function () {
    /* Collection carousels that impulse ran as Flickity wrapAround + cellAlign (text-collection-carousel-rows:
       row 1 left, row 2 right; collection-cards-carousel: settings.cell_align). Embla loop with the same
       alignment: start / end / center. Markup: root has data-embla-src, x-ref="viewport" (overflow hidden,
       data-embla-viewport for deferred images) holds a flex <ul> of slides; arrows from snippets/slider-arrows.
       opts: { align: 'start' | 'end' | 'center', step: 'slide' | 'page', desktopStatic: true when the
       cards fit one row on desktop (impulse watchCSS: static row there, carousel on mobile) } */
    Alpine.data('loopCarousel', function (opts) {
      opts = opts || {};
      var api = null;
      return {
        overflows: false,
        init: function () {
          var self = this;
          ensureEmbla(this.$root).then(function () {
            if (!self.$refs.viewport || api) return;
            var o = { loop: true, align: opts.align || 'start', slidesToScroll: opts.step === 'page' ? 'auto' : 1, duration: 30 };
            if (opts.desktopStatic) o.breakpoints = { '(min-width: 769px)': { active: false } };
            /* The markup may pre-shift the track to where Embla will put it (centre align, no jump on mount);
               Embla must measure the unshifted track, then writes its own transform. */
            var track = self.$refs.viewport.firstElementChild;
            if (track) track.style.transform = 'none';
            api = EmblaCarousel(self.$refs.viewport, o);
            var update = function () { self.overflows = !!api && (api.canScrollNext() || api.canScrollPrev()); };
            api.on('init', update);
            api.on('reInit', update);
            update();
            self.$refs.viewport.addEventListener('dragstart', function (e) {
              if (e.target.closest && e.target.closest('a, img')) e.preventDefault();
            });
          }).catch(function () {});
        },
        next: function () { if (api) api.scrollNext(); },
        prev: function () { if (api) api.scrollPrev(); },
        destroy: function () { if (api) { api.destroy(); api = null; } }
      };
    });

    /* sections/trustpilot-review-collector-form.liquid: order lookup, then the encrypted payload
       goes to the Trustpilot widget. Same flow as zum-impulse (endpoint and copy unchanged). */
    Alpine.data('tpReview', function () {
      var ENDPOINT = 'https://asia-southeast1-zum-trustpilot-506207.cloudfunctions.net/trustpilot-review-payload';
      var ERROR_MSG = 'That order number and email do not match an order. Please use the email you placed the order with and try again.';
      return {
        busy: false,
        error: '',
        verified: false,
        /* The widget attaches its "customerDataResponse" listener only after it loads,
           so the payload is dispatched a few times with backoff. */
        armWidget: function (payload) {
          var widget = this.$refs.widget;
          var tries = 0, max = 6;
          function dispatch() {
            tries++;
            try { widget.dispatchEvent(new CustomEvent('customerDataResponse', { detail: payload })); } catch (e) {}
            if (tries < max) setTimeout(dispatch, 400 * tries);
          }
          if (window.customElements && customElements.whenDefined) {
            customElements.whenDefined('trustbox-verified-review-collector').then(function () { setTimeout(dispatch, 150); });
          } else {
            setTimeout(dispatch, 800);
          }
        },
        submit: function (form) {
          var self = this;
          if (this.busy) return;
          var orderNumber = (form.orderNumber.value || '').trim();
          var email = (form.email.value || '').trim();
          if (!orderNumber || !email) { this.error = ERROR_MSG; return; }
          this.busy = true;
          this.error = '';
          fetch(ENDPOINT, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ orderNumber: orderNumber, email: email })
          })
            .then(function (res) { return res.json().catch(function () { return {}; }).then(function (j) { return { ok: res.ok, body: j }; }); })
            .then(function (r) {
              if (r.ok && r.body && r.body.ok && r.body.payload) {
                self.verified = true;
                self.$nextTick(function () { self.armWidget(r.body.payload); });
              } else {
                self.error = ERROR_MSG;
              }
            })
            .catch(function () { self.error = ERROR_MSG; })
            .then(function () { self.busy = false; });
        }
      };
    });
  });

  /* Theme editor: selecting a block inside a scroll-snap carousel scrolls its slide into view
     (Flickity sections did this in zum-impulse through onBlockSelect). */
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    var track = el && el.parentElement;
    if (!track || !track.classList || !track.classList.contains('snap-track')) return;
    var first = track.children[0];
    track.scrollTo({ left: el.offsetLeft - (first ? first.offsetLeft : 0), behavior: reducedMotion() ? 'auto' : 'smooth' });
  });

  /* Slideshow parallax (impulse parallax-image, data-movement 15%): the image is scaled 115%
     and shifted up to 7.5% each way while its slideshow crosses the viewport. */
  (function () {
    var raf = 0;
    function update() {
      raf = 0;
      var els = document.querySelectorAll('[data-parallax-image]');
      var vh = window.innerHeight;
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        var box = el.parentNode.getBoundingClientRect();
        if (box.bottom < 0 || box.top > vh || box.height === 0) continue;
        var progress = (box.top + box.height) / (vh + box.height);
        var shift = ((progress - 0.5) * 15).toFixed(2);
        el.style.transform = el.getAttribute('data-angle') === 'left'
          ? 'translate3d(' + shift + '%,0,0) scale(1.15)'
          : 'translate3d(0,' + shift + '%,0) scale(1.15)';
      }
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(update); }
    function start() {
      if (reducedMotion() || !document.querySelector('[data-parallax-image]')) return;
      if (!start.bound) {
        start.bound = true;
        window.addEventListener('scroll', schedule, { passive: true });
        window.addEventListener('resize', schedule);
      }
      schedule();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  /* Judge.me review widget: hydrate on approach (zum-impulse custom.js section 18).
     sections/apps.liquid renames data-entry-point to data-jdgm-lazy-entry-point on the product
     review widget, so Judge.me's loader.js skips it at load (its Vue hydration is a 500-600 ms
     main-thread task on mobile). The attribute is renamed back when the widget comes within
     1500px of the viewport, after the first scroll (idle), on a review badge click, or right away
     for review-email links (#judgeme hash, judgeme_* query tokens), and the steps loader.js would
     have run follow: hide the legacy markup, drop the SSR list, add the manifest CSS, load the
     widget module once. */
  (function () {
    var LAZY_ATTR = 'data-jdgm-lazy-entry-point';
    var TOKENS = ['judgeme_token', 'judgeme_review_uuid', 'judgeme_dynamic_form', 'judgeme_follow_up_token', 'judgeme_upload_pictures', 'judgeme_pre_verified'];

    function addCss(base, href) {
      var url = base + href;
      if (document.querySelector('link[href="' + url + '"]')) return;
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = url;
      document.head.appendChild(link);
    }

    function addManifestCss(base, manifest, key, seen) {
      var entry = manifest[key];
      if (!entry || seen[key]) return;
      seen[key] = true;
      (entry.css || []).forEach(function (href) { addCss(base, href); });
      (entry.imports || []).forEach(function (k) { addManifestCss(base, manifest, k, seen); });
    }

    /* Same decision loader.js makes for the review widget (revamp vs legacy content) */
    function shouldLoadRevamp(el) {
      var settings = window.jdgmSettings || {};
      var legacy = el.querySelector('.jdgm-legacy-widget-content');
      var hasLegacy = !!legacy && legacy.innerHTML.trim().length > 20;
      var widgets = window.jdgm && window.jdgm.data && window.jdgm.data.reviewWidget;
      var data = widgets && widgets[el.dataset.productId];
      var hasRevamp = !!(data && data.reviews !== undefined);
      return settings.review_widget_revamp_enabled ? (hasRevamp || !hasLegacy) : (!hasLegacy && hasRevamp);
    }

    function hydrate(el) {
      if (!el.hasAttribute(LAZY_ATTR)) return;
      var entryPoint = el.getAttribute(LAZY_ATTR);
      el.removeAttribute(LAZY_ATTR);
      el.setAttribute('data-entry-point', entryPoint);

      var ssr = el.querySelector('.jdgm-ssr-reviews');
      if (!shouldLoadRevamp(el)) {
        var legacy = el.querySelector('.jdgm-legacy-widget-content');
        if (legacy) legacy.style.display = '';
        if (ssr) ssr.remove();
        return;
      }
      var base = window.jdgm && window.jdgm.CDN_BASE_URL;
      if (!base) return;
      var widg = el.querySelector('.jdgm-rev-widg');
      if (widg) widg.style.display = 'none';
      if (ssr) ssr.remove();

      var src = base + entryPoint;
      function addModule() {
        if (document.querySelector('script[src="' + src + '"]')) return;
        var script = document.createElement('script');
        script.type = 'module';
        script.src = src;
        document.head.appendChild(script);
      }
      fetch(base + 'manifest.json?v=' + Date.now())
        .then(function (r) { return r.json(); })
        .then(function (manifest) { addManifestCss(base, manifest, el.dataset.entryKey, {}); })
        .catch(function () {})
        .then(addModule);
    }

    function hydrateAll() {
      document.querySelectorAll('[' + LAZY_ATTR + ']').forEach(hydrate);
    }

    function init() {
      var widgets = document.querySelectorAll('[' + LAZY_ATTR + ']');
      if (!widgets.length) return;
      /* Drop the hidden SSR list now, as loader.js does at load: left in the DOM, Judge.me's legacy scripts customise its reviews and load media.js */
      widgets.forEach(function (w) { var s = w.querySelector('.jdgm-ssr-reviews'); if (s) s.remove(); });
      var search = window.location.search;
      var fromEmail = window.location.hash.indexOf('#judgeme') === 0 ||
        TOKENS.some(function (t) { return search.indexOf(t) >= 0; });
      if (fromEmail || !('IntersectionObserver' in window)) {
        hydrateAll();
        return;
      }
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          io.unobserve(entry.target);
          hydrate(entry.target);
        });
      }, { rootMargin: '1500px 0px 1500px 0px' });
      widgets.forEach(function (w) { io.observe(w); });
      /* Mount right after the first scroll while the widget is still far below: mounting in view would push ~4.5k px of content down (field CLS) */
      window.addEventListener('scroll', function () {
        if ('requestIdleCallback' in window) requestIdleCallback(hydrateAll, { timeout: 2000 });
        else setTimeout(hydrateAll, 200);
      }, { passive: true, once: true });
    }

    /* A review badge click scrolls to the widget: start hydrating right away */
    document.addEventListener('click', function (e) {
      if (e.target.closest('.jdgm-prev-badge, .review-badge, a[href*="#judgeme"]')) hydrateAll();
    }, true);

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
  })();
})();
